import type { HTMLAttributes } from 'react'
import { cx } from './cx'

export interface IconProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  /** Nome del glifo Material Symbols Outlined (es. "add"). */
  name: string
  size?: 18 | 20 | 24 | 40 | undefined
  filled?: boolean | undefined
}

/** Icona decorativa (aria-hidden di default). Per un'icona informativa passare aria-hidden={false} e aria-label. */
export function Icon({ name, size = 24, filled, className, ...rest }: IconProps) {
  return (
    <span
      aria-hidden="true"
      {...rest}
      className={cx('material-symbols-outlined', 'md-icon', `md-icon--${size}`, filled && 'md-icon--filled', className)}
    >
      {name}
    </span>
  )
}
